import { BiographicalSearchDto } from '@app/api2/api';
import * as Yup from 'yup';

export const BiographicalSearchSchema: Yup.SchemaOf<BiographicalSearchDto> = Yup.object({
    discriminator: Yup.string().required(),
    operator: Yup.string().optional(),
    firstName: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { lastName, dateOfBirth } = this.parent;
            return !!value || !!lastName || !!dateOfBirth;
        }
    ),
    lastName: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { firstName, dateOfBirth } = this.parent;
            return !!value || !!firstName || !!dateOfBirth;
        }
    ),
    dateOfBirth: Yup.date().optional().nullable().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { firstName, lastName } = this.parent;
            return !!value || !!firstName || !!lastName;
        }
    ) as any,
});

type BiographicalSearchTypeMembersObject = Record<keyof BiographicalSearchDto, undefined>;

const bioSearchDefProperties: BiographicalSearchTypeMembersObject = {
    discriminator: undefined,
    operator: undefined,
    firstName: undefined,
    lastName: undefined,
    dateOfBirth: undefined,
};

export const ALL_BIO_SEARCH_PROPERTIES = Object.keys(bioSearchDefProperties) as (keyof BiographicalSearchDto)[];
